import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class GoogleRestServices {
    private httpClient: HttpClient = inject(HttpClient);
    private config: Config = inject(Config);
    private httpHelper: HttpHelper = inject(HttpHelper);

    disableIntegration(successCallback?, errorCallback?) {
        var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/google/oauth2/disable-integration', {
            withCredentials: true,
            observe: 'response',
        });
        return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
    }

    authorize(successCallback?, errorCallback?) {
        var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/google/oauth2/authorize', {
            withCredentials: true,
            observe: 'response',
        });
        return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
    }

    getUserCalendars(successCallback?, errorCallback?) {
        const url = this.config.getRestUrl() + 'rest/google/calendar/user-calendars';

        const httpPromise: any = this.httpClient.get(url, {
            withCredentials: true
        });

        return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
    }

    saveUserCalendar(selectedCalendarId: string, excludedCalendarIds: string[], successCallback?, errorCallback?) {
        const url = this.config.getRestUrl() + 'rest/google/calendar/save-user-calendar';

        const httpPromise: any = this.httpClient.post(url, {
            selectedCalendarId,
            excludedCalendarIds
        }, {
            withCredentials: true
        });

        return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
    }

    checkIntegrationEnabled(successCallback?, errorCallback?) {
        const httpPromise: any = this.httpClient.get(
            this.config.getRestUrl() + 'rest/google/calendar/integration-enabled', {
                withCredentials: true
            });
        return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
    }

    syncGoogleCalendar(successCallback?, errorCallback?) {
        var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'rest/google/calendar/sync-google-calendar', {
            withCredentials: true,
            observe: 'response',
        });
        return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
    }
}